module.exports = require('./loader')



/** WEBPACK FOOTER **
 ** ./src/components/loader/index.js
 **/